var _path, _path2, _path3, _path4, _defs;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgClockicon = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 45.5C12.14 45.5 2.5 35.86 2.5 24C2.5 12.14 12.14 2.5 24 2.5C35.86 2.5 45.5 12.14 45.5 24C45.5 35.86 35.86 45.5 24 45.5ZM24 5.5C13.8 5.5 5.5 13.8 5.5 24C5.5 34.2 13.8 42.5 24 42.5C34.2 42.5 42.5 34.2 42.5 24C42.5 13.8 34.2 5.5 24 5.5Z",
    fill: "url(#paint0_linear_2004_323)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 45.5C12.14 45.5 2.5 35.86 2.5 24C2.5 12.14 12.14 2.5 24 2.5C35.86 2.5 45.5 12.14 45.5 24C45.5 35.86 35.86 45.5 24 45.5ZM24 5.5C13.8 5.5 5.5 13.8 5.5 24C5.5 34.2 13.8 42.5 24 42.5C34.2 42.5 42.5 34.2 42.5 24C42.5 13.8 34.2 5.5 24 5.5Z",
    fill: "url(#paint1_linear_2004_323)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.42 31.86C31.16 31.86 30.9 31.8 30.66 31.64L24.46 27.94C22.92 27.02 21.78 25 21.78 23.22V15.02C21.78 14.2 22.46 13.52 23.28 13.52C24.1 13.52 24.78 14.2 24.78 15.02V23.22C24.78 23.94 25.38 25 26 25.36L32.2 29.06C32.92 29.48 33.14 30.4 32.72 31.12C32.42 31.6 31.92 31.86 31.42 31.86Z",
    fill: "url(#paint2_linear_2004_323)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.42 31.86C31.16 31.86 30.9 31.8 30.66 31.64L24.46 27.94C22.92 27.02 21.78 25 21.78 23.22V15.02C21.78 14.2 22.46 13.52 23.28 13.52C24.1 13.52 24.78 14.2 24.78 15.02V23.22C24.78 23.94 25.38 25 26 25.36L32.2 29.06C32.92 29.48 33.14 30.4 32.72 31.12C32.42 31.6 31.92 31.86 31.42 31.86Z",
    fill: "url(#paint3_linear_2004_323)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2004_323",
    x1: 2.79223,
    y1: 2.5,
    x2: 2.79223,
    y2: 44.9155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3758CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3758CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2004_323",
    x1: 24,
    y1: 2.5,
    x2: 24,
    y2: 45.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3758CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2004_323",
    x1: 21.8558,
    y1: 13.52,
    x2: 21.8558,
    y2: 31.6107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3758CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3758CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2004_323",
    x1: 27.356,
    y1: 13.52,
    x2: 27.356,
    y2: 31.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3758CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgClockicon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/clockicon.1ce3c898.svg";
export { ForwardRef as ReactComponent };